import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Collapse,
  IconButton,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@material-ui/icons';

import CloseIcon from '@material-ui/icons/Close';
// import { fetchAlpatiaDefaultSettings } from '../../../../../containers/actions/ecosystemActions';
// import usePrevious from '../../../../pcmp/components/helpers/previousProps';
import usePrevious from '../../../helpers/previousProps';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
// import { updateOrgProfile } from '../../../../../containers/actions/userActions';
import { orgProfileData, updateOrgProfile } from '../../../../../../containers/actions/userActions';
// import BackDrop from '../../../../../components/pcmp/components/common/models/BackDrop';
import Backdrop from '@material-ui/core/Backdrop';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import { UPDATE_ORG_FAIL } from '../../../../../containers/actions/types';
import { UPDATE_ORG_PROFILE } from '../../../../../../containers/actions/types';
import { Country, State, City } from 'country-state-city';
import postalCodes from 'postal-codes-js';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: '#F5F9FF',
  },
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    backgroundColor: '#F5F9FF',
  },
  head: {
    textAlign: 'center',
  },
  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '12px',
    right: '10px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: '#FF0000',
    },
  },

  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  inline: {
    fontSize: '1.5rem',
    display: 'inline',
    fontWeight: 600,
    marginBottom: '0.5rem',
  },
  hrLine: {
    backgroundColor: 'grey',
    width: '2.5rem',
    height: '3px',
    margin: 'inherit',
    marginBottom: '1rem',
    marginTop: '0.25rem',
  },
  hr: {
    border: '0.5px solid #000000de',
    marginTop: '3rem',
    marginBottom: '2rem',
    width: '100%',
    borderBottom: 'thick',
  },
  textfieldWidth: {
    width: '85%',
    marginTop: '8px',
  },
  hideDropdown: {
    '& .MuiAutocomplete-popupIndicator': {
      display: 'none',
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
  },
  hideDeleteIcon: {
    '& .MuiChip-deleteIcon': {
      display: 'none',
    },

    color: '#000000',
    border: '1px solid #000000',
    marginRight: '4px',
  },

  required: {
    color: 'red',
    marginLeft: '4px',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
    // Additional styles to disable scrolling
    overflow: 'hidden',
    pointerEvents: 'none', // Prevents pointer events on the input
    touchAction: 'none', // Disables touch actions
    userSelect: 'none', // Disables text selection
    resize: 'none', // Prevents resizing
  },
  dialogContent: {
    textAlign: 'center',
    padding: '24px 36px 24px 36px',
  },
  avatar: {
    color: 'green',
    margin: '0 auto',
    fontSize: '54px',
  },
  dialogActions: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
}));



const EditAddressFields = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { openDialog, closeEditAddressFields, fetchedData } = props;
  const [sponsorDetails, setSponsorDetails] = useState({
    selectedCountry:
      Country.getAllCountries().find(
        (country) => country.name === fetchedData.country
      )?.isoCode ?? 'Country not found.',
    states: [],
    selectedState:
      State.getStatesOfCountry(
        Country.getAllCountries().find(
          (country) => country.name === fetchedData.country
        )?.isoCode ?? 'Country not found.'
      ).find((state) => state.name === fetchedData.state)?.isoCode ??
      'State not found.',
    cities: [],
    selectedCity: fetchedData.city,
    postCode: fetchedData.pincode,
    streetAddress1: fetchedData.org_address_1,
    streetAddress2: fetchedData.org_address_2,
  });

  const [errors, setErrors] = useState({
    selectedCountry: '',
    selectedState: '',
    selectedCity: '',
    postCode: '',
    streetAddress1: '',
    streetAddress2: '',
    selectedStatus: '',
  });

  // const connachtCities = City.getCitiesOfState("IE", "C");
  // console.log("Connacht Cities:", connachtCities);
  
  // const otherStateCities = City.getCitiesOfState("IE", "L"); // Replace with another state code
  // console.log("Other State Cities:", otherStateCities);
  

  // Country Name handling functions
  const validateCountry = (value) => {
    return value === '' ? 'Country is required' : '';
  };
  const handleCountryChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({
      ...sponsorDetails,
      selectedCountry: value,
      selectedState: '',
      selectedCity: '',
      postCode: '',
    });
    const errorMessage = validateCountry(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCountry: errorMessage,
      // selectedState: true,
      // selectedCity: true,
    }));
  };

  useEffect(() => {
    if (sponsorDetails.selectedCountry) {
      const states = State.getStatesOfCountry(sponsorDetails.selectedCountry);
      setSponsorDetails((prevDetails) => ({
        ...prevDetails,
        states: states,
        // selectedState: "",
        // postCode: "",
        cities: [],
      }));
    }
  }, [sponsorDetails.selectedCountry]);

  const validateState = (value) => {
    return value === '' ? 'State is required' : '';
  };

  const handleStateChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({
      ...sponsorDetails,
      selectedState: value,
      selectedCity: '',
      postCode: '',
    });
    const errorMessage = validateState(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedState: errorMessage,
      // selectedCity: true,
    }));
  };

  // City Name handling functions

  useEffect(() => {
    if (sponsorDetails.selectedState) {
      const cities = City.getCitiesOfState(
        sponsorDetails.selectedCountry,
        sponsorDetails.selectedState
      );
      setSponsorDetails((prevDetails) => ({
        ...prevDetails,
        cities: cities,
        // selectedCity: "",
      }));
    }
  }, [sponsorDetails.selectedState]);

  const validateCity = (value) => {
    return value === '' ? 'City is required' : '';
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, selectedCity: value, postCode: '' });
    const errorMessage = validateCity(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCity: errorMessage,
    }));
  };

  // Post Code handling functions

  const validatePostCode = (value, country) => {
    if (value.trim() === '') {
      return 'Post Code is required';
    }
    if (country) {
      const isValid = postalCodes.validate(country, value);
      if (isValid === true) {
        return '';
      } else {
        return 'Invalid postal code';
      }
    }
    return '';
  };

  const handlePostCodeChange = (event) => {
    const value = event.target.value;
    const country = sponsorDetails.selectedCountry;

    setSponsorDetails({ ...sponsorDetails, postCode: value });

    const errorMessage = validatePostCode(value, country);
    setErrors((prevErrors) => ({ ...prevErrors, postCode: errorMessage }));
  };

  const validateStreetAddress1 = (value) => {
    return value.trim() === '' ? 'Street Address 1 is required' : '';
  };

  const handleStreetAddress1Change = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, streetAddress1: value });
    const errorMessage = validateStreetAddress1(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress1: errorMessage,
    }));
  };

  const validateStreetAddress2 = (value) => {
    return value.trim() === '' ? 'Street Address 2 is required' : '';
  };
  const handleStreetAddress2Change = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, streetAddress2: value });
    const errorMessage = validateStreetAddress2(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress2: errorMessage,
    }));
  };

  const didMountRef = useRef(false);

  const [updateError, setUpdateError] = useState(false);
  const [updateErrorMessage, setUpdateErrorMessage] = useState('');
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const orgDetails = useSelector((state) => state.user.orgDetails);

  const prevOrgDetails = usePrevious(orgDetails);
  const updateOrgFail = useSelector((state) =>
    state.user?.updateOrgDetails ? state.user.updateOrgDetails : {}
  );

  const prevUpdateOrgFail = usePrevious(updateOrgFail);
  useEffect(() => {
    if (didMountRef.current) {
      // Perform a deep comparison using isEqual from lodash
  
      if (JSON.stringify(updateOrgFail) !== JSON.stringify(prevUpdateOrgFail)) {
        if (updateOrgFail.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdateErrorMessage('');
          setOpenSuccessDialog(true);
        } else {
          // setLoading(false);
          setUpdateError(true);
          setUpdateErrorMessage(
            'Something went wrong. Please contact Alpatia Support'
          );
          setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [updateOrgFail, prevUpdateOrgFail]);

  const handleClose = () => {
    setOpenSuccessDialog(false);
    closeEditAddressFields();
    dispatch(orgProfileData());
  };

  const handleSave = () => {
    // setOpen(true);

    const updatePayload = {};

    if (sponsorDetails.streetAddress1 !== fetchedData.org_address_1) {
      updatePayload.org_address_1 = sponsorDetails.streetAddress1;
    }
    if (sponsorDetails.streetAddress2 !== fetchedData.org_address_2) {
      updatePayload.org_address_2 = sponsorDetails.streetAddress2;
    }
    if (sponsorDetails.selectedCity !== fetchedData.city) {
      updatePayload.city = sponsorDetails.selectedCity;
    }
    if (
      sponsorDetails.selectedState !==
        State.getStatesOfCountry(
          Country.getAllCountries().find(
            (country) => country.name === fetchedData.country
          )?.isoCode ?? 'Country not found.'
        ).find((state) => state.name === fetchedData.state)?.isoCode ??
      'State not found.'
    ) {
      updatePayload.state =
        State.getStatesOfCountry(sponsorDetails.selectedCountry).find(
          (state) => state.isoCode === sponsorDetails.selectedState
        )?.name ?? 'State not found.';
    }
    if (sponsorDetails.postCode !== fetchedData.pincode) {
      updatePayload.pincode = sponsorDetails.postCode;
    }
    if (
      sponsorDetails.selectedCountry !==
        Country.getAllCountries().find(
          (country) => country.name === fetchedData.country
        )?.isoCode ??
      'Country not found.'
    ) {
      updatePayload.country =
        Country.getAllCountries().find(
          (country) => country.isoCode === sponsorDetails.selectedCountry
        )?.name ?? 'Country not found.';
    }

    dispatch(updateOrgProfile(updatePayload));
  };

  const handleCancel = () => {
    dispatch({
      type: UPDATE_ORG_PROFILE,
      payload: {},
    });
    closeEditAddressFields();
  };

  return (
    <>
      <Backdrop />
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: '0px' }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant='h6' style={{ fontSize: '1.875rem' }}>
                  Edit Address Details
                </Typography>
                <Typography>
                  Please update the Address in the field below.
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant='body2'
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{' '}
                <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent
          style={{
            paddingLeft: '140px',
            paddingTop: '32px',
          }}
        >
          {updateOrgFail?.updateFail === true && (
            <Grid
              style={{
                // paddingLeft: "150px",
                paddingTop: '8px',
                width: '87%',
                paddingBottom: '16px',
              }}
            >
              {/* {Object.keys(updatedData.errorDescription).map((key) => ( */}
              <Typography
                variant='h6'
                style={{
                  border: '1px solid #FF0000',
                  backgroundColor: '#FFF0F0',
                  opacity: '1',
                  textAlign: 'center',
                  padding: '0.8rem',
                  fontSize: '0.875rem',
                }}
              >
                {/* {updatedData.errorDescription[key]} */}
                {updateOrgFail.data.errorMessage}
              </Typography>
              {/* ))} */}
            </Grid>
          )}

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant='body2' className={classes.inline}>
                Address Details
              </Typography>
              <hr className={classes.hrLine} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                Street Address 1 <span className={classes.required}>*</span>
              </Typography>
              <TextField
                size='small'
                variant='outlined'
                inputProps={{ maxLength: 40 }}
                className={classes.textfieldWidth}
                value={sponsorDetails.streetAddress1}
                onChange={handleStreetAddress1Change}
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    handleStreetAddress1Change({ target: { value: value.trim() } });
                  }
                }}
                error={errors.streetAddress1 !== ''}
                helperText={errors.streetAddress1}
                onInput={(e) => {
                  e.target.value = e.target.value
                    // Allow only letters, digits, spaces, commas, periods, hyphens, and slashes
                    .replace(/[^a-zA-Z0-9\s,.\-\/]/g, '')
                    .replace(/(\s{2,}|,{2,}|\.{2,}|-{2,}|\/{2,})/g, '');
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                Street Address 2 <span className={classes.required}>*</span>
              </Typography>
              <TextField
                size='small'
                variant='outlined'
                inputProps={{ maxLength: 40 }}
                className={classes.textfieldWidth}
                value={sponsorDetails.streetAddress2}
                onChange={handleStreetAddress2Change}
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    handleStreetAddress2Change({ target: { value: value.trim() } });
                  }
                }}
                error={errors.streetAddress2 !== ''}
                helperText={errors.streetAddress2}
                onInput={(e) => {
                  e.target.value = e.target.value
                    // Allow only letters, digits, spaces, commas, periods, hyphens, and slashes
                    .replace(/[^a-zA-Z0-9\s,.\-\/]/g, '')
                    .replace(/(\s{2,}|,{2,}|\.{2,}|-{2,}|\/{2,})/g, '');
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                City <span className={classes.required}>*</span>
              </Typography>
              <TextField
                size='small'
                select
                variant='outlined'
                className={classes.textfieldWidth}
                value={sponsorDetails.selectedCity}
                onChange={handleCityChange}
                //   disabled={!selectedState}
                error={errors.selectedCity !== ''}
                helperText={errors.selectedCity}
              >
                {sponsorDetails.cities.length === 0 ? (
                  <MenuItem disabled>No Cities Found</MenuItem>
                ) : (
                  sponsorDetails.cities.map((city) => (
                    <MenuItem key={city.name} value={city.name}>
                      {city.name}
                    </MenuItem>
                  ))
                )}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                State <span className={classes.required}>*</span>
              </Typography>
              <TextField
                size='small'
                select
                variant='outlined'
                className={classes.textfieldWidth}
                value={sponsorDetails.selectedState}
                onChange={handleStateChange}
                //   disabled={!selectedCountry}
                error={errors.selectedState !== ''}
                helperText={errors.selectedState}
              >
                {sponsorDetails.states.length === 0 ? (
                  <MenuItem disabled>No States Found</MenuItem>
                ) : (
                  sponsorDetails.states.map((state) => (
                    <MenuItem key={state.isoCode} value={state.isoCode}>
                      {state.name}
                    </MenuItem>
                  ))
                )}
              </TextField>
            </Grid>

<Grid item xs={12} sm={6}>
              <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                Post Code <span className={classes.required}>*</span>
              </Typography>
              <TextField
                size='small'
                variant='outlined'
                inputProps={{ maxLength: 12 }}
                className={classes.textfieldWidth}
                value={sponsorDetails.postCode}
                onChange={handlePostCodeChange}
                error={errors.postCode !== ''}
                helperText={errors.postCode}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^a-zA-Z0-9\s-]/g, '')
                    .replace(/(\s{2,}|-{2,})/g, ''); // Allow only digits, letters, spaces, and hyphens
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                Country
                <span className={classes.required}>*</span>
              </Typography>

              <TextField
                size='small'
                select
                variant='outlined'
                className={classes.textfieldWidth}
                value={sponsorDetails.selectedCountry}
                onChange={handleCountryChange}
                error={errors.selectedCountry !== ''}
                helperText={errors.selectedCountry}
              >
                {Country.getAllCountries().map((country) => (
                  <MenuItem key={country.isoCode} value={country.isoCode}>
                    {country.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

          </Grid>

          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              style={{ paddingTop: '24px', paddingBottom: '24px' }}
            >
              <Typography>
                <span style={{ fontWeight: '500' }}>Note: </span>All fields
                marked with an asterisk (<span style={{ color: 'red' }}>*</span>
                ) are mandatory.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Button
                variant='contained'
                color='primary'
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  marginRight: '7rem',
                }}
                onClick={handleSave}
                disabled={
                  [
                    'selectedCountry',
                    'selectedState',
                    'selectedCity',
                    'postCode',
                    'streetAddress1',
                    'streetAddress2',
                  ].some((field) => sponsorDetails[field] === '') ||
                  [
                    'selectedCountry',
                    'selectedState',
                    'selectedCity',
                    'postCode',
                    'streetAddress1',
                    'streetAddress2',
                  ].some((field) => errors[field] !== '') ||
                  (fetchedData.country ===
                    (Country.getAllCountries().find(
                      (country) =>
                        country.isoCode === sponsorDetails.selectedCountry
                    )?.name || 'Country not found.') &&
                    fetchedData.state ===
                      (State.getStatesOfCountry(
                        sponsorDetails.selectedCountry
                      ).find(
                        (state) =>
                          state.isoCode === sponsorDetails.selectedState
                      )?.name || 'State not found.') &&
                    fetchedData.city === sponsorDetails.selectedCity &&
                    sponsorDetails.streetAddress1 ===
                      fetchedData.org_address_1 &&
                    sponsorDetails.streetAddress2 ===
                      fetchedData.org_address_2 &&
                    sponsorDetails.postCode === fetchedData.pincode)
                }
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </DialogContent>

        <Dialog open={openSuccessDialog} maxWidth='sm' fullWidth>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.avatar} />

            <Typography variant='h6' style={{ marginTop: '10px' }}>
              Address details saved
            </Typography>
            <Typography variant='body1' style={{ marginTop: '10px' }}>
              The address details have been updated successfully.
            </Typography>

            <DialogActions className={classes.dialogActions}>
              <Button
                variant='contained'
                color='primary'
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: '20px',
                  textTransform: 'none',
                }}
                onClick={handleClose}
              >
                Ok
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </Dialog>
    </>
  );
};


export default EditAddressFields;
